var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "workflow-archival-basic" }, [
    _c(
      "header",
      [
        _c(
          "flex-grid",
          [
            _c(
              "flex-grid-item",
              { attrs: { grow: "1" } },
              [
                _c("text-input", {
                  attrs: {
                    label: "Workflow ID",
                    name: "workflowId",
                    type: "search",
                    value: _vm.workflowId
                  },
                  on: { input: _vm.onTextChange }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "flex-grid-item",
              { attrs: { grow: "1" } },
              [
                _c("text-input", {
                  attrs: {
                    label: "Workflow Name",
                    name: "workflowName",
                    type: "search",
                    value: _vm.workflowName
                  },
                  on: { input: _vm.onTextChange }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "flex-grid-item",
              { attrs: { width: "160px" } },
              [
                _c("select-input", {
                  attrs: {
                    label: "Status",
                    options: _vm.statusList,
                    value: _vm.status
                  },
                  on: { change: _vm.onSelectChange }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "flex-grid-item",
              { attrs: { width: "165px" } },
              [
                _c("text-input", {
                  attrs: {
                    label: "Filter by",
                    readonly: "",
                    value: _vm.filterBy
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "flex-grid-item",
              { attrs: { width: "325px" } },
              [
                _c("date-range-picker", {
                  attrs: { "date-range": _vm.range },
                  on: { change: _vm.onDateRangeChange }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "flex-grid-item",
              { attrs: { width: "120px" } },
              [
                _c("button-fill", {
                  attrs: {
                    label: "ADVANCED",
                    tag: "router-link",
                    to: {
                      name: "workflow-archival-advanced",
                      params: { clusterName: _vm.clusterName }
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "results" },
      [
        _c(
          "archival-table",
          {
            directives: [
              {
                name: "infinite-scroll",
                rawName: "v-infinite-scroll",
                value: _vm.nextPage,
                expression: "nextPage"
              }
            ],
            attrs: {
              "infinite-scroll-disabled": "disableInfiniteScroll",
              "infinite-scroll-distance": "20",
              "infinite-scroll-immediate-check": "false"
            }
          },
          _vm._l(_vm.formattedResults, function(result) {
            return _c("archival-table-row", {
              key: result.runId,
              attrs: {
                "close-status": result.closeStatus,
                "close-time": result.closeTime,
                "cluster-name": _vm.clusterName,
                "domain-name": result.domainName,
                "run-id": result.runId,
                "start-time": result.startTime,
                "workflow-id": result.workflowId,
                "workflow-name": result.workflowName
              }
            })
          }),
          1
        ),
        _vm._v(" "),
        _c("error-message", { attrs: { error: _vm.error } }),
        _vm._v(" "),
        _c("no-results", { attrs: { results: _vm.results } }),
        _vm._v(" "),
        _vm.loading ? _c("loading-spinner") : _vm._e(),
        _vm._v(" "),
        _c(
          "loading-message",
          { attrs: { delay: _vm.loadingMessageDelay, loading: _vm.loading } },
          [
            _c("p", [
              _vm._v(
                "It looks like this request is taking some time to process."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Try narrowing the time range to improve search time.")
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a06a802", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a06a802","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/domain/workflow-archival/basic.vue
// module id = 1772
// module chunks = 0